import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconColumnWideHalf: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"column-wide-half"} maskId="square-filled-radius-0-stroke-1-IconColumnWideHalf"><path d="M2 11.5V4H22V11.5H2Z" fill="currentColor"/><path d="M2 12.5V20H22V12.5H2Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconColumnWideHalf;
